// easing presets
const easings = {
	enterEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', // quad ease-out
	moveEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
	exitEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
};

function getButtonFromEvent( e ) {
	let target = e.target;

	while ( target && target.parentNode ) {
		if ( target.classList.contains( 'wp-block-button__link' ) && ! target.closest( '.wp-block-button.is-style-default-link' ) ) {
			return target;
		}

		target = target.parentNode;
	}

	return false;
}

function getButtonEffect( button ) {
	let effect = button.querySelector( '.wp-block-button__effect' );

	if ( ! effect ) {
		effect = document.createElement( 'span' );
		effect.className = 'wp-block-button__effect';
		button.appendChild( effect );
	}

	return effect;
}

// function to get position percentages
function getXY( e, button ) {
	const rect   = button.getBoundingClientRect();
	const x      = e.clientX - rect.left;
	const y      = e.clientY - rect.top;

	// transform to percentages (0-100)
	const xPercent = ( x / rect.width ) * 100;
	const yPercent = ( y / rect.height ) * 100;

	return { x: xPercent, y: yPercent };
};

// create transform setters
function setTransform( node, scale, x, y ) {
	node.style.transform = `translate3d(${ x }%, ${ y }%, 0) scale(${ scale })`;
};

// set the transition with specific easing
function setTransition( node, duration, easing ) {
	node.style.transition = `transform ${ duration }ms ${ easing }`;
};

function onPointerEnter( e ) {
	const button = getButtonFromEvent( e );

	if ( ! button ) {
		return;
	}

	const { x, y } = getXY( e, button );
	const effect   = getButtonEffect( button );

	// immediate placement with no transition
	effect.style.transition = 'none';
	setTransform( effect, 0, x, y );

	// use requestAnimationFrame to ensure immediate rendering in next frame
	requestAnimationFrame( () => {
		// set transition for entrance animation
		setTransition( effect, 250, easings.enterEase );

		// trigger animation in the next frame
		requestAnimationFrame( () => {
			setTransform( effect, 1, x, y );
		} );
	} );
}

function onPointerMove( e ) {
	const button = getButtonFromEvent( e );

	if ( ! button ) {
		return;
	}

	const { x, y } = getXY( e, button );
	const effect = getButtonEffect( button );

	// set transition for move animation
	setTransition( effect, 250, easings.moveEase );

	// update position
	setTransform( effect, 1, x, y );
}

function onPointerLeave( e ) {
	const button = getButtonFromEvent( e );

	if ( ! button ) {
		return;
	}

	const { x, y } = getXY( e, button );
	const effect   = getButtonEffect( button );

	// calculate exit direction
	const rect = button.getBoundingClientRect();
	const exitX = e.clientX - rect.left;
	const exitY = e.clientY - rect.top;

	// determine which edge was crossed and exaggerate
	let xExit = x;
	let yExit = y;

	if ( exitX <= 0 ) xExit = -20; // left edge
	else if ( exitX >= rect.width ) xExit = 120; // right edge

	if ( exitY <= 0 ) yExit = -20; // top edge
	else if ( exitY >= rect.height ) yExit = 120; // bottom edge

	// set transition for movement to exit position
	setTransition( effect, 250, easings.moveEase );

	// immediately move to exit position
	setTransform( effect, 1, xExit, yExit );

	// slight delay before scaling down
	setTimeout( () => {
		// set transition for scale animation
		setTransition( effect, 300, easings.exitEase );

		// scale down at exit position
		setTransform( effect, 0, xExit, yExit );
	}, 100 );
}

document.body.addEventListener( 'pointerenter', onPointerEnter, true );
document.body.addEventListener( 'pointermove', onPointerMove, true );
document.body.addEventListener( 'pointerleave', onPointerLeave, true );
